import { VpIcon, VpIconButton } from '@vtmn-play/react';
import { ChangeEvent } from 'react';
import './tablePagination.scss';

interface TablePaginationProps {
  numberPages: number;
  currentPage: number | null;
  setCurrentPage: (index: number | null) => void;
  itemsPerPage: number;
  setItemsPerPage: (index: number) => void;
}

export const TablePagination = ({
  numberPages,
  currentPage,
  setCurrentPage,
  itemsPerPage,
  setItemsPerPage,
}: TablePaginationProps) => {
  const selectableItemsPerPage = [10, 20, 30, 40, 50];

  const onChangeItemsPerPage = (e: ChangeEvent<HTMLSelectElement>) => {
    if (Number(e.target.value) !== itemsPerPage) {
      setCurrentPage(1);
      setItemsPerPage(Number(e.target.value));
    }
  };

  const isChevronDisabled = (comparisonIndex: number) =>
    currentPage === comparisonIndex ||
    currentPage === null ||
    numberPages === 1;

  const handleInputChange = (value?: string) => {
    const page = value ? Number(value) : null;
    if (Number(value) > numberPages) {
      return setCurrentPage(numberPages);
    }
    setCurrentPage(page);
  };

  return (
    <div data-testid="table-pagination" className="table-pagination">
      <div className="pagination-navigation">
        <VpIconButton
          size="small"
          variant="secondary"
          data-testid="table-pagination_button_previous-page"
          disabled={isChevronDisabled(1)}
          onClick={() => {
            currentPage && setCurrentPage(currentPage - 1);
          }}
        >
          <VpIcon name="chevron-backward" />
        </VpIconButton>
        <span data-testid="table-pagination_input-container_change-page">
          <input
            className="input_page-number"
            value={currentPage ?? ''}
            data-testid="table-pagination_input_change-page"
            onChange={(event) => handleInputChange(event.target.value)}
            type="number"
            min="1"
            max={numberPages}
            disabled={numberPages === 1}
          />
          of {numberPages}
        </span>
        <VpIconButton
          size="small"
          variant="secondary"
          data-testid="table-pagination_button_next-page"
          disabled={isChevronDisabled(numberPages)}
          onClick={() => {
            currentPage && setCurrentPage(currentPage + 1);
          }}
        >
          <VpIcon name="chevron-forward" />
        </VpIconButton>
      </div>
      <div className="pagination-number">
        Show
        <div className="pagination-number-display">
          <select
            onChange={onChangeItemsPerPage}
            value={itemsPerPage}
            className="select_items-per-page"
          >
            {selectableItemsPerPage.map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
        </div>
        per page
      </div>
    </div>
  );
};
